export type ViewerPresentationMode = 'default' | 'mls'

const MLS_ALIAS_VALUES = new Set(['1', 'true', 'yes', 'on'])

export function resolveViewerPresentationMode(searchParams: URLSearchParams): ViewerPresentationMode {
  const platform = (searchParams.get('platform') || '').trim().toLowerCase()
  const mlsAlias = (searchParams.get('mls') || '').trim().toLowerCase()

  if (platform === 'mls' || MLS_ALIAS_VALUES.has(mlsAlias)) {
    return 'mls'
  }

  return 'default'
}

export function isMlsPresentationMode(mode: ViewerPresentationMode): boolean {
  return mode === 'mls'
}

export function withViewerPresentationParams(url: URL, mode: ViewerPresentationMode): URL {
  if (mode === 'mls') {
    url.searchParams.set('platform', 'mls')
    url.searchParams.delete('mls')
  } else {
    url.searchParams.delete('platform')
    url.searchParams.delete('mls')
  }

  return url
}
